import { DragTableProps, DragTable } from '../DragTable/DragTable';
import {
  StandardTableProps,
  StandardTable,
} from '../StandardTable/StandardTable';

export type SmartTableProps<T extends string | number> =
  | {
      type: 'draggable';
      value: DragTableProps<T>;
    }
  | {
      type: 'standard';
      value: StandardTableProps<T>;
    };

export const SmartTable = <T extends string | number>(p: SmartTableProps<T>) =>
  p.type === 'draggable' ? (
    <DragTable {...p.value} />
  ) : (
    <StandardTable {...p.value} />
  );
